import { IconSeeker } from "@ui-seeker/core"
import { AppBulkEditAction, AppDialogCancel } from "@components"
import React from "react"
import { clearDrawerData, editUserId, isValidatingUser, originalUserData, userErrorRegistry, userPayload } from "Pages/Admin/Users/@signals"
import useCreateUsersModal from "Pages/Admin/Users/@hooks/useCreateModal"
import { useComputed } from "@preact/signals-react"
import { computeDiff } from "Pages/Admin/Users/@utils/diff"

export default function UserCreateFooter() {

	const { onRequestSave, isEditLoading } = useCreateUsersModal()

	const hasChanges = useComputed(() => {
		if (!editUserId.value) return true
		return computeDiff(originalUserData.value, userPayload.value).length > 0
	})

	return <>
		<AppDialogCancel onClick={clearDrawerData}/>
		<AppBulkEditAction
			sx={{ minWidth: 103 }}
			disabled={isEditLoading || !hasChanges.value || Object.values(userErrorRegistry.value)?.some(e => !e) || isValidatingUser.value}
			startIcon={<IconSeeker icon="floppy-disk"/>}
			onClick={onRequestSave}
			loading={isEditLoading}
		>
			Save
		</AppBulkEditAction>
	</>
}
